module.exports = __webpack_public_path__ + "media/images/costumes/top/swiper-dress-2-7959ebdd593517a8a556709379269dd9.jpg";